import { StyleProps } from '@chakra-ui/react';
import { Box, Container, Heading } from '@hover/blueprint';
import React from 'react';
import Statistic from './Statistic';
import Investors from './Investors';
import WorkWithUs from './WorkWithUs';

const headingStyles: StyleProps = {
  mt: { base: 700, tablet: 1000 },
  mb: 700,
  textAlign: { base: 'center', tablet: 'left' },
  maxW: '6xl',
  fontWeight: { base: 600, desktop: 700 },
};

const AboutHover: React.FC = () => (
  <Box bg="green.100" mt={{ desktop: 800 }} pb="70px" w="100%">
    <Container
      maxW="1248px"
      overflow="hidden"
      px={{ base: 500, tablet: '56px', desktop: 500 }}
    >
      <Box
        flexDir="column"
        alignItems={{ base: 'center', tablet: 'flex-start' }}
      >
        <Heading
          as="h2"
          size={{ base: 500, tablet: 600, desktop: 700 }}
          {...headingStyles}
        >
          HOVER is headquartered in San Francisco, with an office in Rochester,
          NY and employees distributed across the US.
        </Heading>
        <WorkWithUs />
      </Box>
      <Statistic />
      <Investors />
    </Container>
  </Box>
);

export default AboutHover;
